import axios from 'axios';

export const base_be_url = "https://adventureclub.nissan-web-apps.com/bck/index.php";

export const base_be_booking_url = "https://adventureclub.nissan-web-apps.com/bck/api/booking.php";

export function sendLeadsToSalesforce(base_url, postData) {
    return axios.post(base_url, postData);
}

export function updateSalesforceLead(base_url, postData) {
    return axios.patch(base_url, postData);
}